import {
  DetentionPeriodValueType,
  PRODUCT_FILTER_CONFIG_PER_COUNTRY,
  type CountryType,
  type PossibleFiltersType
} from '@carrefour-gcs/shared';
import { defineStore, storeToRefs } from 'pinia';
import { useUserStore } from './user.store';

type FiltersStoreStateType = {
  filters: PossibleFiltersType;
};

export const useFiltersStore = defineStore('filters', {
  state: (): FiltersStoreStateType => ({
    filters: {}
  }),
  getters: {
    getFilters: (state): PossibleFiltersType => {
      return state.filters;
    }
  },
  actions: {
    setFilters(filters: PossibleFiltersType) {
      this.filters = { ...this.filters, ...filters };
    },
    setFilter<T extends keyof PossibleFiltersType>(key: T, value: PossibleFiltersType[T]) {
      if (key) {
        this.filters[key] = value;
      }
    },
    resetFilters() {
      const { defaultKpisPerimeter, userCountry } = storeToRefs(useUserStore());

      this.setFilters({
        productFilterType: PRODUCT_FILTER_CONFIG_PER_COUNTRY[userCountry.value as CountryType].filterType,
        isWithTax: defaultKpisPerimeter.value.isWithTax,
        isMyDataIncluded: true,
        storePerimeter: defaultKpisPerimeter.value.storePerimeter,
        taxonomy: 'carrefour',
        selectedFilters: defaultKpisPerimeter.value.filters,
        referentialIntervals: defaultKpisPerimeter.value.referentialIntervals,
        selectedPeriod: defaultKpisPerimeter.value.period,
        comparisonPeriod: { comparisonMode: 'previousYear' },
        detentionPeriod: DetentionPeriodValueType['14Days']
      });
    }
  }
});
